const externalLinks = () => {
  Array.from(document.getElementsByTagName('a')).forEach(link => {   
    if (link.host !== window.location.host) {
      link.target = '_blank'
      link.rel = 'noopener noreferrer'
    }
  });
}

document.addEventListener('turbolinks:load', externalLinks)